exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body {\r\n  height: 100%;\r\n}\r\n\r\n#example1 {\r\n  height: 90%;\r\n}\r\n\r\n.example-svg {\r\n  border: 1px solid orange;\r\n}\r\n\r\n.example-node {\r\n    fill: brown;\r\n    stroke: black;\r\n    stroke-width: 1px;\r\n}\r\n\r\n.example-link {\r\n    stroke-width: 2px;\r\n}\r\n\r\n\r\n    ", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/style.css
// module id = 466
// module chunks = 0